<template>
    <div class="modal fade" :id="'vmbc-cart'+ id" role="dialog">
        <div class="modal-dialog modal-lg">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{productname}}</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">

                <div class="col-sm-12 mb-2">
                    <div class="row">
                        <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="options.option_name" placeholder="Option Name">
                        </div>
                        <div class="col-sm-2">
                            <input type="number" class="form-control" v-model="options.quantity" placeholder="Quantity">
                        </div>
                        <div class="col-sm-2">
                            <input type="number" class="form-control" v-model="options.price" placeholder="Price">
                        </div>
                        <div class="col-sm-2">
                            <button class="btn btn-success btn-block" @click="OptionAdd">Save</button>
                        </div>
                    </div>

                </div>

                <div class="col-sm-12">
                    <table class="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>Option Name</th>
                                <th>Quantity</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in products" :key="product.id">
                                <td><input type="text" v-model="product.option_name" class="form-control"></td>
                                <td><input type="text" v-model="product.quantity" class="form-control"></td>
                                <td><input type="text" v-model="product.price" class="form-control"></td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>

            <div class="modal-footer">
                <button class="btn btn-primary" @click="UpdateAllOptions">
                                Save
                            </button>
                <button type="button" class="btn btn-default" data-dismiss="modal"><i class="fa fa-times"></i></button>
            </div>
        </div>

        </div>
    </div>
</template>

<script>
export default {
    props: ['products', 'id', 'productname', 'refresh'],
    data() {
        return {
            options:{
                id: this.id,
                option_name: '',
                quantity: '',
                price: '',
                isProduct: 1,
                created_at: new Date(),
                updated_at: new Date(),
            },
        }
    },

    methods: {
        OptionAdd() {
            if(this.options.option_name !=='' && this.options.price !=='' && this.options.quantity !==''){
                axios
                .post('./api/Option/Others/Add', {
                    id: this.options.id,
                    option: this.options.option_name,
                    quantity: this.options.quantity,
                    price: this.options.price,
                    user_id: this.$root.id,
                    name: this.$root.staffname,

                })
                .then(response =>
                this.products.push(this.options),
                );

                // this.options.option_name = ''
                // this.options.price = ''
                // this.options.quantity = ''
            }
        },
        UpdateAllOptions(products){
            axios
            .post('./api/Option/Others/Update', {
                products: this.products,
                user_id: this.$root.id,
                name: this.$root.staffname
            })
            .then(response => console.log(response),
            $('.modal').modal('hide')
            )
        }


    },

}
</script>



// WEBPACK FOOTER //
// resources/js/Item/Product/OtherProductOption.vue